import React, { useState, useEffect } from "react";
import moment from "moment";
import moment2 from "moment-timezone";
import { useSignal, useSlot } from 'react-signal-slot'
import { BaseLotInfoByUser } from "../../../Models/Lots/BaseLotInfoByUser"
import LotGallery from "./LotGallery";
import AgentHelper from "../../../CategoryLotsList/AgentHelper/AgentHelper"
import { StepBetType } from "../../../enums/StepBetType"
import { TradeStatus } from "../../../enums/TradeStatus"
import { PaymentType } from "../../../enums/PaymentType"
import { HubConnectionBuilder } from "@microsoft/signalr";
import { Payment } from "../../../Models/Payments/Payment";
import { getFailedTradeReason } from "./remote";
import AccountInfo from "../../../Profile/AccountInfo";
import LotWinnerProtocol2 from "../../../Common/Document/LotWinnerProtocol2";
import DocumentsTable from "../../../Tables/DocumentsTable";
import { TableMode } from "../../../enums/TableTypes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
const queryClient = new QueryClient();

export class BaseComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    init(state) {

        this.state = state;

        var lot = this.state.Lot;

        console.log('BaseComponent lot = ', this.state.Lot);

        if (this.state.Lot == null)
            this.state.Lot = {};

        const hubConnection = new HubConnectionBuilder()
            .withUrl(`/betting?lotId=${lot.Id}`)
            .withAutomaticReconnect()
            .build();

        hubConnection.on('NewBet', (obj) => {
            if (obj.Price && obj.BettorName) {
                console.log("Сделанная ставка идёт в веб-сокет", obj);
                this.AddNewBet(obj);
            }
        });

        hubConnection.start()
            .then(() => console.log('SignalR Connected'))
            .catch((err) => console.error('SignalR Connection Error: ', err));

        return () => {
            console.log("SignalR stopped");
            hubConnection.stop();
        };
    }

    GetDate(date) {
        return moment2(date).format("DD.MM.YYYY HH:mm")
    }

    WinnerProtocolSection() {
        console.log("lotId in CreateProtocole", this.props.lotId);
        if (this.state.Lot.LotTradeStatusId == TradeStatus.Traded || this.state.Lot.LotTradeStatusId == TradeStatus.TradeAbandoned) {
            return (
                <LotWinnerProtocol2 lotId={this.props.lotId} LotTradeStatusId={this.state.Lot.LotTradeStatusId} />
            )
        }

        return null;
    }

    AddNewBet(data) {
        console.log('AddNewBet', data);
        var bets = this.state.Lot.Bets;

        if (bets == null || bets == undefined)
            bets = [];

        bets.push({
            Id: data.Id,
            CompanyId: data.BettorId,
            UserName: data.BettorName,
            Price: data.Price,
            StartPriceDate: data.DateCreated
        });

        this.setState({
            ...this.state,
            Lot: {
                ...this.state.Lot,
                Bets: bets,
                CurrentPrice: data.Price,
                CountBets: bets.length
            },
        });
    }

    getGallery(lotId, pictures, isFavorite) {
        return (<LotGallery pictures={pictures} lotId={lotId} IsFavoriteLot={isFavorite} />);
    }

    getCadastrNumber(filters) {
        console.log('filters=',filters);
        if (filters.find(item => item.FilterName === 'Кадастровый номер')) {
            return (filters.find(item => item.FilterName === 'Кадастровый номер').Value)
        }
    }

    Documents() {
        return (
            <div className="documents">
                <h4 className="defaultDataTitle">Электронные документы</h4>

                <QueryClientProvider client={queryClient}>
                    <DocumentsTable
                        data={this.state.Lot.Documents}
                        Mode={TableMode.View}
                    />
                </QueryClientProvider>
            </div>
        );
    }

    Bets() {
        return (
            <div className="lotBets detailsWrapper">
                <table>
                    <thead>
                        <tr>
                            <th className="defaultDataName">Пользователь</th>
                            <th className="defaultDataName">Цена</th>
                            <th className="defaultDataName">Дата</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.Lot.Bets && this.state.Lot.Bets.length != 0 ? (
                            this.state.Lot.Bets.map((bet, index) => {
                                return (
                                    <tr key={index}>
                                        <td className="defaultDataValue">{bet.UserName}</td>
                                        <td className="defaultDataValue">{bet.Price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ₽</td>
                                        <td className="defaultDataValue">{moment(bet.StartPriceDate).format('HH:mm:ss DD.MM.YYYY')}</td>
                                    </tr>
                                )
                            })
                        ) : (
                            <p className="errorText">Ставок пока нет. Вы можете стать первым!</p>
                        )}
                    </tbody>
                </table>
            </div>
        );
    }

    ContactInfo() {

        return (
            <div className="lotContacts detailsWrapper">
                <div className="contactItem">
                    <span className="defaultDataName">Телефон горячей линии:</span>
                    <a href="tel:74951473765" className="defaultDataValue">+7 (495) 147-37-65</a>
                </div>

                <div className="contactItem">
                    <span className="defaultDataName">Электронная почта:</span>
                    <a href="mailto:support@viomitra.ru" className="defaultDataValue">support@viomitra.ru</a>
                </div>
            </div>
        )
    }

    ContactButtons() {
        return (
            <div className="contactButtons">
                <a className="defaultPinkBorderButton containerForDefaultPopup">
                    <div className="popupRender">
                        <AgentHelper
                            addition={'Заявка со страницы лота - Помощь агента'}
                        />
                    </div>
                    Помощь агента
                </a>
                <a className="defaultPinkBorderButton containerForDefaultPopup">
                    <div className="popupRender">
                        <AgentHelper
                            addition={'Заявка со страницы лота - Заказ онлайн показа'}
                            poputTitle={'Заказать онлайн показ'}
                        />
                    </div>
                    Заказать онлайн показ
                </a>
            </div>
        );
    }

    ShortInfoLot() {
        return (
            <React.Fragment>
                <div className="infoItem">
                    <span>Статус:</span>
                    <h5>{this.state.Lot.LotTradeStatusDescription}</h5>
                </div>

                <div className="infoItem">
                    <span>Сделано ставок:</span>
                    <h5>{this.state.Lot.CountBets}</h5>
                </div>

                <div className="infoItem">
                    <span>Вид торгов:</span>
                    <h5>{this.state.Lot.TradeTypeDescription}</h5>
                </div>
            </React.Fragment>
        );
    }

    ShowFailedTradeReason() {
        /* если аукцион не состоялся. Выведем причину по которой он не состоялся. */
        if (this.state.Lot.LotTradeStatusId == TradeStatus.TradeAbandoned) {
            return (
                <div className="infoItem">
                    <span>Причина несостоявшихся торгов:</span>
                    <h5>{this.state.Lot.FailedTradeReasonText || "Неизвестная причина"}</h5>
                </div>
            );
        }
    }

    calculateStep() {
        var stepValue = 1;
        if (this.state.Lot.Bets === null) {
            stepValue = this.state.Lot.CurrentPrice
        }
        else {
            if (this.state.Lot.StepBet == StepBetType.IsPercent)
                stepValue = this.state.Lot.CurrentPrice + (this.state.Lot.BasePrice * this.state.Lot.StepPercent / 100)
            else if (this.state.Lot.StepBet == StepBetType.IsValue)
                stepValue = this.state.Lot.CurrentPrice + this.state.Lot.StepValue;
            else
                stepValue = this.state.Lot.CurrentPrice + 1;
        }
        

        return stepValue;
    }

    getPayment(payments: Array<Payment>, type: PaymentType)
    {
        if (payments == null)
            return null;

        var item = payments.filter(f => f.TypeId == type)[0];

        return item;
    }
}